import { render, staticRenderFns } from "./ProfileInfoCard.vue?vue&type=template&id=c78c9322"
import script from "./ProfileInfoCard.vue?vue&type=script&lang=js"
export * from "./ProfileInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports